import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  min-width: 80px;
  max-width: 200px;
  padding: 8px;
  margin-top: -32px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
`;

export const LogoImage = styled.img`
  height: 100%;
  max-width: 100%;
  object-fit: contain;
`;
